import lang from 'quasar/lang/zh-TW.js'
import Cookies from 'quasar/src/plugins/Cookies.js';import Loading from 'quasar/src/plugins/Loading.js';import Notify from 'quasar/src/plugins/Notify.js';import QSpinnerPuff from 'quasar/src/components/spinner/QSpinnerPuff.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';

export default {
  config: {
    brand: {
      /* Customization color setup for CRM */
      info: '#0099FF'
    },
    loading: {
      /* look at QuasarConfOptions from the API card */ spinner: QSpinnerPuff,
      spinnerColor: 'primary'
    }
  },
  plugins: {
    Cookies,
    Loading,
    Notify,
    LocalStorage
  },
  lang: lang
}
